import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorSummaryService {
  private active = false;
  activeErrorSummary: EventEmitter<boolean> = new EventEmitter();
  closeAllErrorSummary: EventEmitter<boolean> = new EventEmitter();

  handleChangeActiveErrorSummary(active: boolean): void {
    this.active = active;
    this.activeErrorSummary.emit(active);
  }

  handleGetActiveErrorSummary(): boolean {
    return this.active;
  }

  closeAllAccordionsErrorSummary(): void {
    this.closeAllErrorSummary.emit(true);
  }
}
